// extracted by mini-css-extract-plugin
export default {"wrapper":"rA-z","viewport":"sA-z","container":"tA-z","slide":"uA-z"};